import { render, staticRenderFns } from "./Desk.ProcessesTable.vue?vue&type=template&id=3c55a98a&scoped=true"
import script from "./Desk.ProcessesTable.vue?vue&type=script&lang=js"
export * from "./Desk.ProcessesTable.vue?vue&type=script&lang=js"
import style0 from "./Desk.ProcessesTable.vue?vue&type=style&index=0&id=3c55a98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55a98a",
  null
  
)

export default component.exports